import axios from 'axios';

export const moduleOptionApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/module-option`,
    headers: {
        'Content-Type': 'application/json'
    }
})